import styled from 'styled-components';

import Stepper from '@rover/components/src/formFields/Stepper';
import type { RoverTheme } from '@rover/types/src/RoverTheme';

export const mobileStyle = { height: '100%' };
export const getDesktopStyle = (theme: RoverTheme) => ({
  border: `${theme.borderWidth.primary} solid ${theme.colors.border.primary}`,
  borderRadius: theme.radii.secondary,
  padding: theme.space['5x'],
  paddingTop: theme.space['6x'],
});

export const StyledStepper = styled(Stepper)`
  input {
    font-weight: 600;
    font-size: ${({ theme }) => theme.text['200'].fontSize};
    border: 0px !important;
  }
  button[disabled] {
    background-color: ${({ theme }) => theme.colors.border.primary};
    border: ${({ theme }) => theme.borderWidth.primary} solid
      ${({ theme }) => theme.colors.border.primary};
  }
  button {
    color: ${({ theme }) => theme.background.interactive.primary_base};
    background-color: ${({ theme }) => theme.colors.interactive_text.primary_base};
    border: ${({ theme }) => theme.borderWidth.primary} solid
      ${({ theme }) => theme.colors.interactive_text.primary_base};
    box-shadow: none;

    &:not([disabled]):hover,
    &:not([disabled]):active {
      color: ${({ theme }) => theme.background.interactive.primary_base};
      background-color: ${({ theme }) => theme.colors.interactive_text.primary_base};
    }
  }
`;
